import { Permission } from 'shared'
import { EditRowActionOptions } from '../../../../../../../../../../../components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  RequestForInformation,
  useRFITrackerContext,
} from '../../../../RFITrackerContext'
import {
  EditRFIModalBody,
  EditRFIModalValues,
} from './components/EditRFIModalBody'
import { toMoment } from '../../../../../../../../../../../utils/toMoment'
import { useProjectCustomFieldsContext } from '../../../../../../../../../../../components/CustomFields/ProjectCustomFieldsContext'

export function useEditOptions(): EditRowActionOptions<
  RequestForInformation,
  EditRFIModalValues
> {
  const { refetch, edit } = useRFITrackerContext()
  const { toCustomFieldEditorValue, toMutateCustomFieldsInput } =
    useProjectCustomFieldsContext()
  return {
    permission: Permission.EditRequestForInformation,
    modal: {
      type: 'simple',
      recordName: 'formattedNumber',
      body: (record) => <EditRFIModalBody {...record} />,
      initialValues: ({
        description,
        responseDisciplines,
        organizationId,
        requestedResponseDate,
        externalLinks,
        customFields,
      }) => ({
        description,
        responseDisciplineIds: responseDisciplines.map(({ id }) => id),
        organizationId,
        requestedResponseDate: toMoment(requestedResponseDate),
        externalLinks: externalLinks.map(({ __typename, ...link }) => link),
        customFields: toCustomFieldEditorValue(customFields),
      }),
      onOk: async (
        rfi,
        {
          description,
          responseDisciplineIds,
          organizationId,
          requestedResponseDate,
          externalLinks,
          customFields,
        }
      ) => {
        await edit({
          variables: {
            editRequestForInformationInput: {
              id: rfi.id,
              description,
              organizationId: organizationId ?? null,
              responseDisciplineIds,
              requestedResponseDate:
                requestedResponseDate?.toISOString() ?? null,
              externalLinks,
              customFields: toMutateCustomFieldsInput(customFields),
            },
          },
        })
        refetch()
      },
    },
  }
}
